export const languageData = [
  {
    languageId: 'english',
    locale: 'en',
    name: 'English',
    icon: 'us',
  },
  {
    languageId: 'croatian',
    locale: 'hr',
    name: 'Hrvatski',
    icon: 'hr',
  },
];

export const flags = {
  en: '/images/flag/icons8-usa.png',
  hr: '/images/flag/icons8-croatia.png',
};
